import { Component, Inject } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';

@Component({
    selector: 'lsq-not-found',
    template: `
        <div class="container-fluid page-container page">
            <div class="error-page-container">
                <div class="error-page-copy">
                    <h1>Oops!</h1>
                    <p>We can't seem to find the page you're looking for.</p>
                    <lsq-button (buttonClick)="handleClick()">
                        {{ buttonText }}
                    </lsq-button>
                </div>
                <div class="error-page-image-container"></div>
            </div>
        </div>
    `
})
export class LsqNotFoundComponent {
    public buttonText? = 'Take me home';
    public icons = Icons;
    public colors = Color;

    constructor(@Inject(SETTINGS) private _settings: ISettings, private _userService: UserService) {
        if (this._settings.pageNotFoundButtonText) {
            this.buttonText = this._settings.pageNotFoundButtonText;
        }
    }

    public handleClick(): void {
        this._userService.navigateToHome();
    }
}
